import React, { useState, useMemo, useRef, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Checkbox,
  Select,
  MenuItem,
  TextField,
  CircularProgress,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { isMobile } from "react-device-detect";
import { Helmet } from "react-helmet";
import logoImage from "../../../assets/images/logo.png";
import logoWebpay from "../../../assets/images/webpay.png";
import { KeyboardArrowDown } from "@mui/icons-material";
import InfoIcon from '@mui/icons-material/Info';
import { useEffect } from "react";
import invokeApi from "../../../services/invokeApi";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

// Array de países en el orden específico solicitado
const COUNTRIES = [
  { code: "+56", name: "Chile", digits: 9 },
  { code: "+54", name: "Argentina", digits: 10 },
  { code: "+1", name: "Estados Unidos", digits: 10 },
  { code: "+34", name: "España", digits: 9 },
  { code: "+46", name: "Suecia", digits: 9 },
  { code: "+1", name: "Canadá", digits: 10 },
  { code: "+61", name: "Australia", digits: 9 },
  { code: "+55", name: "Brasil", digits: 11 },
  { code: "+33", name: "Francia", digits: 10 },
  { code: "+49", name: "Alemania", digits: 11 },
  { code: "+51", name: "Perú", digits: 9 },
  { code: "+93", name: "Afganistán", digits: 9 },
  { code: "+355", name: "Albania", digits: 9 },
  { code: "+213", name: "Argelia", digits: 9 },
  { code: "+376", name: "Andorra", digits: 6 },
  { code: "+244", name: "Angola", digits: 9 },
  { code: "+43", name: "Austria", digits: 10 },
  { code: "+973", name: "Baréin", digits: 8 },
  { code: "+880", name: "Bangladesh", digits: 10 },
  { code: "+32", name: "Bélgica", digits: 9 },
  { code: "+501", name: "Belice", digits: 7 },
  { code: "+591", name: "Bolivia", digits: 8 },
  { code: "+267", name: "Botsuana", digits: 8 },
  { code: "+359", name: "Bulgaria", digits: 9 },
  { code: "+257", name: "Burundi", digits: 8 },
  { code: "+855", name: "Camboya", digits: 9 },
  { code: "+237", name: "Camerún", digits: 9 },
  { code: "+86", name: "China", digits: 11 },
  { code: "+357", name: "Chipre", digits: 8 },
  { code: "+57", name: "Colombia", digits: 10 },
  { code: "+506", name: "Costa Rica", digits: 8 },
  { code: "+385", name: "Croacia", digits: 9 },
  { code: "+53", name: "Cuba", digits: 8 },
  { code: "+45", name: "Dinamarca", digits: 8 },
  { code: "+593", name: "Ecuador", digits: 9 },
  { code: "+20", name: "Egipto", digits: 10 },
  { code: "+503", name: "El Salvador", digits: 8 },
  { code: "+372", name: "Estonia", digits: 8 },
  { code: "+251", name: "Etiopía", digits: 9 },
  { code: "+358", name: "Finlandia", digits: 9 },
  { code: "+233", name: "Ghana", digits: 9 },
  { code: "+30", name: "Grecia", digits: 10 },
  { code: "+502", name: "Guatemala", digits: 8 },
  { code: "+504", name: "Honduras", digits: 8 },
  { code: "+852", name: "Hong Kong", digits: 8 },
  { code: "+36", name: "Hungría", digits: 9 },
  { code: "+91", name: "India", digits: 10 },
  { code: "+62", name: "Indonesia", digits: 10 },
  { code: "+98", name: "Irán", digits: 10 },
  { code: "+964", name: "Irak", digits: 10 },
  { code: "+353", name: "Irlanda", digits: 9 },
  { code: "+354", name: "Islandia", digits: 7 },
  { code: "+972", name: "Israel", digits: 9 },
  { code: "+39", name: "Italia", digits: 10 },
  { code: "+81", name: "Japón", digits: 10 },
  { code: "+962", name: "Jordania", digits: 9 },
  { code: "+7", name: "Kazajistán", digits: 10 },
  { code: "+254", name: "Kenia", digits: 9 },
  { code: "+996", name: "Kirguistán", digits: 9 },
  { code: "+965", name: "Kuwait", digits: 8 },
  { code: "+371", name: "Letonia", digits: 8 },
  { code: "+961", name: "Líbano", digits: 8 },
  { code: "+218", name: "Libia", digits: 9 },
  { code: "+370", name: "Lituania", digits: 8 },
  { code: "+352", name: "Luxemburgo", digits: 9 },
  { code: "+60", name: "Malasia", digits: 9 },
  { code: "+960", name: "Maldivas", digits: 7 },
  { code: "+356", name: "Malta", digits: 8 },
  { code: "+212", name: "Marruecos", digits: 9 },
  { code: "+52", name: "México", digits: 10 },
  { code: "+373", name: "Moldavia", digits: 8 },
  { code: "+377", name: "Mónaco", digits: 8 },
  { code: "+976", name: "Mongolia", digits: 8 },
  { code: "+95", name: "Myanmar", digits: 9 },
  { code: "+977", name: "Nepal", digits: 10 },
  { code: "+505", name: "Nicaragua", digits: 8 },
  { code: "+234", name: "Nigeria", digits: 8 },
  { code: "+47", name: "Noruega", digits: 8 },
  { code: "+64", name: "Nueva Zelanda", digits: 9 },
  { code: "+31", name: "Países Bajos", digits: 9 },
  { code: "+92", name: "Pakistán", digits: 10 },
  { code: "+507", name: "Panamá", digits: 8 },
  { code: "+595", name: "Paraguay", digits: 9 },
  { code: "+63", name: "Filipinas", digits: 10 },
  { code: "+48", name: "Polonia", digits: 9 },
  { code: "+351", name: "Portugal", digits: 9 },
  { code: "+974", name: "Catar", digits: 8 },
  { code: "+44", name: "Reino Unido", digits: 10 },
  { code: "+420", name: "República Checa", digits: 9 },
  { code: "+40", name: "Rumania", digits: 9 },
  { code: "+7", name: "Rusia", digits: 10 },
  { code: "+378", name: "San Marino", digits: 6 },
  { code: "+966", name: "Arabia Saudí", digits: 9 },
  { code: "+65", name: "Singapur", digits: 8 },
  { code: "+421", name: "Eslovaquia", digits: 9 },
  { code: "+386", name: "Eslovenia", digits: 8 },
  { code: "+27", name: "Sudáfrica", digits: 9 },
  { code: "+82", name: "Corea del Sur", digits: 10 },
  { code: "+94", name: "Sri Lanka", digits: 9 },
  { code: "+41", name: "Suiza", digits: 9 },
  { code: "+66", name: "Tailandia", digits: 9 },
  { code: "+90", name: "Turquía", digits: 10 },
  { code: "+380", name: "Ucrania", digits: 9 },
  { code: "+598", name: "Uruguay", digits: 8 },
  { code: "+58", name: "Venezuela", digits: 10 },
  { code: "+84", name: "Vietnam", digits: 9 },
];

const isValidText = (text) => text.length >= 1;

// Validación completa de email
const validateEmail = (email) => {
  if (!email) {
    return { isValid: false, message: "El correo es obligatorio" };
  }
  if (email.length < 5) {
    return { isValid: false, message: "El correo debe tener al menos 5 caracteres" };
  }
  if (email.length > 254) {
    return { isValid: false, message: "El correo no puede tener más de 254 caracteres" };
  }
  if (email.includes(" ")) {
    return { isValid: false, message: "El correo no puede contener espacios" };
  }
  if (!/^[\x00-\x7F]*$/.test(email)) {
    return { isValid: false, message: "El correo no puede contener tildes ni caracteres especiales" };
  }
  const atCount = (email.match(/@/g) || []).length;
  if (atCount === 0) {
    return { isValid: false, message: "El correo debe incluir @" };
  }
  if (atCount > 1) {
    return { isValid: false, message: "El correo debe tener solo un @" };
  }
  const atIndex = email.indexOf("@");
  const localPart = email.substring(0, atIndex);
  const domain = email.substring(atIndex + 1);
  if (localPart.length === 0) {
    return { isValid: false, message: "Debe haber texto antes del @" };
  }
  if (localPart.length > 64) {
    return { isValid: false, message: "La parte antes del @ no puede tener más de 64 caracteres" };
  }
  if (!/^[a-zA-Z0-9._%+-]+$/.test(localPart)) {
    return { isValid: false, message: "El correo contiene caracteres no permitidos antes del @" };
  }
  // Regla técnica: la parte local (antes del @) no puede comenzar ni terminar con "."
  // Mensaje simplificado para usuarios no técnicos en flujo de compra
  if (localPart.startsWith(".") || localPart.endsWith(".")) {
    return { isValid: false, message: "Tu correo no puede empezar ni terminar con punto" };
  }
  if (localPart.includes("..")) {
    return { isValid: false, message: "El correo no puede tener puntos consecutivos" };
  }
  if (domain.length === 0) {
    return { isValid: false, message: "Debe haber texto después del @" };
  }
  // Regla técnica: el dominio debe contener al menos un "." (ej: gmail.com)
  // Mensaje simplificado para usuarios no técnicos en flujo de compra
  if (!domain.includes(".")) {
    return { isValid: false, message: "Después del @ debe ir algo como gmail.com" };
  }
  // Regla técnica: el dominio solo acepta caracteres alfanuméricos, puntos y guiones
  // Mensaje simplificado para usuarios no técnicos en flujo de compra
  if (!/^[a-zA-Z0-9.-]+$/.test(domain)) {
    return { isValid: false, message: "Después del @ solo puede haber letras, números y puntos" };
  }
  if (domain.startsWith(".") || domain.endsWith(".")) {
    return { isValid: false, message: "El dominio no puede empezar ni terminar con punto" };
  }
  if (domain.includes("..")) {
    return { isValid: false, message: "El dominio no puede tener puntos consecutivos" };
  }
  const domainParts = domain.split(".");
  for (let part of domainParts) {
    // Regla técnica: no puede haber segmentos vacíos entre puntos (ej: gmail..com)
    // Mensaje simplificado para usuarios no técnicos en flujo de compra
    if (part.length === 0) {
      return { isValid: false, message: "Revisa los puntos después del @" };
    }
    // Regla técnica: cada segmento del dominio no puede comenzar ni terminar con guion
    // Mensaje simplificado para usuarios no técnicos en flujo de compra
    if (part.startsWith("-") || part.endsWith("-")) {
      return { isValid: false, message: "Revisa los guiones después del @" };
    }
  }
  const tld = domainParts[domainParts.length - 1];
  // Regla técnica: el TLD (ej: .com, .cl) debe tener entre 2 y 63 caracteres y solo letras
  // Mensajes simplificados para usuarios no técnicos en flujo de compra
  if (tld.length < 2) {
    return { isValid: false, message: "Falta la terminación del correo, ej: .com" };
  }
  if (tld.length > 63) {
    return { isValid: false, message: "El final del correo es demasiado largo" };
  }
  if (!/^[a-zA-Z]+$/.test(tld)) {
    return { isValid: false, message: "El final del correo solo puede tener letras, ej: .com, .cl" };
  }
  return { isValid: true, message: "" };
};

const isValidEmail = (email) => validateEmail(email).isValid;

const isValidPhone = (phoneData) => {
  if (!phoneData || !phoneData.countryCode || !phoneData.number) return false;
  const country = COUNTRIES.find(c => c.code === phoneData.countryCode);
  if (!country) return false;
  return phoneData.number.length === country.digits && /^\d+$/.test(phoneData.number);
};

const getEmailValidationMessage = (email) => {
  return validateEmail(email).message;
};

const areEmailsEqual = (email1, email2) => {
  return email1.toLowerCase() === (email2 || "").toLowerCase();
};

const getValidationAlert = (nombreCompleto, email, confirmEmail, telefono) => {
  if (!isValidText(nombreCompleto)) {
    return "Ingrese su nombre";
  }
  const emailMessage = getEmailValidationMessage(email);
  if (emailMessage) {
    return emailMessage;
  }
  if (email && !areEmailsEqual(email, confirmEmail)) {
    return "Los correos electrónicos no son iguales";
  }
  if (!isValidPhone(telefono)) {
    const country = COUNTRIES.find(c => c.code === telefono?.countryCode);
    const digits = country ? country.digits : 9;
    return `El teléfono debe tener ${digits} dígitos después de ${telefono?.countryCode || "+56"}`;
  }
  return "";
};

const redirectToTransbank = (token, url) => {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = url;
  const tokenInput = document.createElement('input');
  tokenInput.type = 'hidden';
  tokenInput.name = 'token_ws';
  tokenInput.value = token;
  form.appendChild(tokenInput);
  document.body.appendChild(form);
  form.submit();
};

function ContenidoComprar() {
  const location = useLocation();
  const navigate = useNavigate();
  const MySwal = withReactContent(Swal);
  
  const [nombreCompleto, setNombreCompleto] = useState("");
  const [email, setEmail] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");
  const [telefono, setTelefono] = useState({ countryCode: "+56", number: "" });
  const [isLoading, setIsLoading] = useState(false);

  // Estados para bottom sheet de info cargo por servicio
  const [showInfoSheet, setShowInfoSheet] = useState(false);
  const [isClosingSheet, setIsClosingSheet] = useState(false);
  const sheetRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }, 0);
  }, []);

  const isContentFree = useMemo(() => {
    const contenidoPrecio = location.state?.contenido_precio_clp || "";
    return contenidoPrecio.toLowerCase().includes("gratis");
  }, [location.state?.contenido_precio_clp]);

  // Función para cerrar bottom sheet con animación
  const closeSheet = useCallback(() => {
    setIsClosingSheet(true);
    setTimeout(() => {
      setShowInfoSheet(false);
      setIsClosingSheet(false);
    }, 220);
  }, []);

  // Cerrar al hacer click fuera de la caja
  useEffect(() => {
    if (!showInfoSheet) return;

    const handleClickOutside = (e) => {
      if (sheetRef.current && !sheetRef.current.contains(e.target)) {
        closeSheet();
      }
    };

    const timer = setTimeout(() => {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("touchstart", handleClickOutside);
    }, 100);

    return () => {
      clearTimeout(timer);
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [showInfoSheet, closeSheet]);

  const isFormValid = useMemo(() => {
    return (
      isValidText(nombreCompleto) &&
      isValidEmail(email) &&
      isValidEmail(confirmEmail) &&
      areEmailsEqual(email, confirmEmail) &&
      isValidPhone(telefono)
    );
  }, [nombreCompleto, email, confirmEmail, telefono]);

  const pageTitle = "Clinifica - Comprar Contenido";
  const pageDescription = "Completa tu compra de contenido especializado.";

  if (!location.state) {
    return (
      <>
        <Helmet>
          <title>{pageTitle}</title>
          <meta name="description" content={pageDescription} />
        </Helmet>
        
        <Box
          component="img"
          src={logoImage}
          alt="Clinifica Logo"
          sx={{
            width: { xs: "150px", md: "200px" },
            height: "auto",
            display: "block",
            mx: "auto",
            p: "15px",
          }}
        />
        
        <Box
          sx={{
            maxWidth: { xs: "94%", md: "800px" },
            width: { xs: "94%", md: "90%" },
            mx: "auto",
            bgcolor: "#fbfafe",
            boxShadow: 1,
            marginTop: 2,
            marginBottom: 8,
            borderRadius: 2,
            p: { xs: 2, md: 4 },
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "400px",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Quicksand-Regular",
              fontSize: { md: "16px", xs: "14px" },
              color: "#9e9e9e",
              textAlign: "center",
            }}
          >
            No se pudo cargar la información del contenido
          </Typography>
        </Box>
      </>
    );
  }

  const {
    contenido_nombre,
    contenido_precio_clp,
    contenido_precio_cargo_plataforma_clp,
    contenido_precio_total_clp,
    profesional_nombres,
    profesional_apellidos,
    profesional_profesion,
    contenidoCompleto,
    profesionalCompleto
  } = location.state;

  // Precios calculados en backend y recibidos vía location.state
  const precioBase = contenido_precio_clp;
  const cargoServicio = contenido_precio_cargo_plataforma_clp;
  const precioTotal = contenido_precio_total_clp;


  const handleChangeNombreCompleto = (event) => {
    setNombreCompleto(event.target.value);
  };

  const handleChangeEmail = (event) => {
    setEmail(event.target.value);
  };
  
  const handleChangeConfirmEmail = (event) => {
    setConfirmEmail(event.target.value);
  };

  const handleChangeCountry = (event) => {
    setTelefono({ countryCode: event.target.value, number: "" });
  };

  const handleChangeTelefono = (event) => {
    let inputValue = event.target.value.replace(/\D/g, "");
    const country = COUNTRIES.find(c => c.code === telefono.countryCode);
    const maxLength = country ? country.digits : 9;
    inputValue = inputValue.slice(0, maxLength);
    setTelefono({ ...telefono, number: inputValue });
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  const mapearMetodoPago = (isContentFree) => {
    if (isContentFree) return 'free';
    return 'webpay';
  };

  const handlePagar = async () => {
    if (!isFormValid) return;
    
    try {
      setIsLoading(true);
      
      const { contenidoCompleto, profesionalCompleto } = location.state || {};
      
      if (!contenidoCompleto || !profesionalCompleto) {
        MySwal.fire("Error", "No se pudo cargar la información del contenido", "error");
        return;
      }
      
      if (!contenidoCompleto.id_contenido || !profesionalCompleto.id_profesional_fantasma) {
        MySwal.fire("Error", "Faltan datos necesarios para procesar la compra", "error");
        return;
      }

      const metodoPagoMapeado = mapearMetodoPago(isContentFree);

      const payload = {
        comprador_nombre: nombreCompleto,
        comprador_correo: email,
        comprador_telefono: `${telefono.countryCode}${telefono.number}`,
        id_contenido: contenidoCompleto.id_contenido,
        id_profesional_fantasma: profesionalCompleto.id_profesional_fantasma,
        metodo_pago: metodoPagoMapeado,
        divisa: "CLP"
      };
      
      const response = await invokeApi("/agenda/contenidoCheckout", "post", payload);
      
      if (response.error) {
        MySwal.fire("Error", "Hubo un problema procesando tu compra. Intenta nuevamente.", "error");
        return;
      }
      
      if (response && response.statusCode === 200) {
        if (isContentFree) {
          navigate(`/contenido/checkout/status?id_checkout=${response.id_checkout}`);
        } else {
          if (response.webpay && response.webpay.token && response.webpay.url) {
            redirectToTransbank(response.webpay.token, response.webpay.url);
          } else {
            MySwal.fire("Error", "No se recibieron datos de Transbank", "error");
          }
        }
      } else {
        MySwal.fire("Error", "Respuesta inesperada del servidor", "error");
      }
      
    } catch (error) {
      console.error("Error al procesar compra:", error);
      MySwal.fire("Error", "Error inesperado. Intenta nuevamente.", "error");
    } finally {
      setIsLoading(false);
    }
  };

  const getFieldContainerStyle = () => ({
    borderRadius: 2,
    border: "1px solid #909090",
    backgroundColor: "white",
    p: 0.5,
    "&:focus-within": {
      borderColor: "#3B82F6",
      boxShadow: "0 0 0 1px #3B82F6",
    },
  });

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
      </Helmet>
      
      {/* Logo — responsivo con sx */}
      <Box
        component="img"
        src={logoImage}
        alt="Clinifica Logo"
        sx={{
          width: { xs: "150px", md: "200px" },
          height: "auto",
          display: "block",
          mx: "auto",
          p: "15px",
        }}
      />

      {/* Caja de resumen */}
      <Box
        translate="no"
        className="notranslate"
        sx={{
          maxWidth: { xs: "94%", md: "800px" },
          width: { xs: "94%", md: "90%" },
          mx: "auto",
          bgcolor: "#fbfafe",
          boxShadow: 1,
          marginTop: 2,
          marginBottom: 2,
          borderRadius: 2,
          p: { xs: 2, md: 4 },
        }}
      >
        <Typography sx={{ 
          fontFamily: "Quicksand-Regular",
          color: "#626262",
          fontSize: { xs: "14px", md: "16px" },
          mb: 0
        }}>
          Estas comprando:
        </Typography>
        <Typography
          sx={{
            mt: -0.5,
            fontFamily: "Quicksand-Bold",
            fontSize: { xs: "18px", md: "20px" },
            color: "#191C1F",
            mb: 0
          }}
        >
          {contenido_nombre}
        </Typography>
        {/* Pill "Contenido" */}
        <Box
          sx={{
            display: "inline-block",
            backgroundColor: "#f0f4ff",
            color: "#3B82F6",
            fontFamily: "Quicksand-Medium",
            fontSize: { md: "15px", xs: "13px" },
            borderRadius: 2,
            paddingLeft: 0.75,
            paddingRight: 0.75,
            paddingTop: 0.25,
            paddingBottom: 0.25,
            marginLeft: -0.75,
            mt: -0.75,
            textAlign: "left",
          }}
        >
          Contenido
        </Box>
        <Typography
          sx={{ 
            fontFamily: "Quicksand-Regular", 
            mt: 0,
            fontSize: { md: "16px", xs: "14px" },
            color: "#191C1F",
            mb: 0
          }}
        >
          {precioBase}
        </Typography>

        <Typography sx={{ 
          fontFamily: "Quicksand-Regular",
          color: "#626262",
          mt: 2,
          fontSize: { xs: "14px", md: "16px" },
          mb: 0
        }}>
          Creado por:
        </Typography>
        <Typography
          sx={{
            mt: -0.5,
            fontFamily: "Quicksand-Bold",
            fontSize: { xs: "18px", md: "20px" },
            color: "#191C1F",
            mb: 0
          }}
        >
          {profesional_nombres} {profesional_apellidos}
        </Typography>
        <Typography sx={{ 
          fontFamily: "Quicksand-Regular", 
          mt: -0.5,
          fontSize: { md: "16px", xs: "14px" },
          color: "#191C1F",
          mb: 0
        }}>
          {profesional_profesion}
        </Typography>
      </Box>

      {/* Título */}
      <Typography
        sx={{
          fontFamily: "Quicksand-Bold",
          fontSize: { md: "24px", xs: "20px" },
          textAlign: "center",
          color: "#191C1F",
          mt: 3,
          mb: 1
        }}
      >
        Datos del comprador
      </Typography>

      {/* Formulario */}
      <Box
        translate="no"
        className="notranslate"
        sx={{
          maxWidth: { xs: "94%", md: "800px" },
          width: { xs: "94%", md: "90%" },
          mx: "auto",
          bgcolor: "white",
          boxShadow: 1,
          marginTop: 2,
          marginBottom: 8,
          borderRadius: 2,
          p: { xs: 2, md: 4 },
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: { xs: "100%", md: "66.67%" },
            mx: "auto",
          }}
        >
          <Typography
            sx={{
              mt: 3,
              mb: 1,
              fontFamily: "Quicksand-Regular",
              fontSize: { md: "16px", xs: "14px" },
              color: "#191C1F",
              textAlign: "center",
            }}
          >
            ✨ Ingrese los siguientes datos para comprar
          </Typography>

          {/* Nombre completo */}
          <Box sx={{ mb: 0 }}>
            <Typography
              sx={{
                pt: 1,
                fontFamily: isValidText(nombreCompleto)
                  ? "Quicksand-Bold"
                  : "Quicksand-Regular",
                fontSize: { md: "16px", xs: "14px" },
                color: isValidText(nombreCompleto) ? "#2669A8" : "#191C1F",
              }}
            >
              {isValidText(nombreCompleto) ? "Nombre completo" : "Nombre completo"}
            </Typography>
            <Box sx={getFieldContainerStyle()}>
              <TextField
                value={nombreCompleto}
                onChange={handleChangeNombreCompleto}
                inputProps={{ maxLength: 50 }}
                variant="standard"
                fullWidth
                InputProps={{
                  disableUnderline: true,
                  sx: {
                    border: "none",
                    outline: "none",
                    background: "transparent",
                    fontFamily: "Quicksand-Regular",
                    color: "#4F4F4F",
                    fontSize: { md: "16px", xs: "14px" },
                    "& input": { padding: 0 },
                  },
                }}
              />
            </Box>
          </Box>  

          {/* Email */}
          <Box sx={{ mb: 0 }}>
            <Typography
              sx={{
                pt: 1,
                fontFamily: isValidEmail(email) ? "Quicksand-Bold" : "Quicksand-Regular",
                fontSize: { md: "16px", xs: "14px" },
                color: isValidEmail(email) ? "#2669A8" : "#191C1F",
              }}
            >
              {isValidEmail(email) ? "Correo electrónico" : "Correo electrónico"}
            </Typography>
            <Box sx={getFieldContainerStyle()}>
              <TextField
                type="email"
                value={email}
                onChange={handleChangeEmail}
                inputProps={{ maxLength: 100 }}
                variant="standard"
                fullWidth
                InputProps={{
                  disableUnderline: true,
                  sx: {
                    border: "none",
                    outline: "none",
                    background: "transparent",
                    fontFamily: "Quicksand-Regular",
                    color: "#4F4F4F",
                    fontSize: { md: "16px", xs: "14px" },
                    "& input": { padding: 0 },
                  },
                }}
              />
            </Box>
          </Box>

          {/* Confirmar Email */}
          <Box sx={{ mb: 0 }}>
            <Typography
              sx={{
                pt: 1,
                fontFamily:
                  email && confirmEmail && areEmailsEqual(email, confirmEmail)
                    ? "Quicksand-Bold"
                    : "Quicksand-Regular",
                fontSize: { md: "16px", xs: "14px" },
                color:
                  email && confirmEmail && areEmailsEqual(email, confirmEmail)
                    ? "#2669A8"
                    : "#191C1F",
              }}
            >
              {email && confirmEmail && areEmailsEqual(email, confirmEmail)
                ? "Confirmar correo electrónico"
                : "Confirmar correo electrónico"}
            </Typography>
            <Box sx={getFieldContainerStyle()}>
              <TextField
                type="email"
                value={confirmEmail}
                onChange={handleChangeConfirmEmail}
                onPaste={(e) => e.preventDefault()}
                inputProps={{ maxLength: 100 }}
                variant="standard"
                fullWidth
                InputProps={{
                  disableUnderline: true,
                  sx: {
                    border: "none",
                    outline: "none",
                    background: "transparent",
                    fontFamily: "Quicksand-Regular",
                    color: "#4F4F4F",
                    fontSize: { md: "16px", xs: "14px" },
                    "& input": { padding: 0 },
                  },
                }}
              />
            </Box>
          </Box>

          {/* Teléfono */}
          <Box sx={{ mb: 2 }}>
            <Typography
              sx={{
                pt: 1,
                fontFamily: isValidPhone(telefono) ? "Quicksand-Bold" : "Quicksand-Regular",
                fontSize: { md: "16px", xs: "14px" },
                color: isValidPhone(telefono) ? "#2669A8" : "#191C1F",
              }}
            >
              {isValidPhone(telefono) ? "Teléfono" : "Teléfono"}
            </Typography>
            <Box sx={getFieldContainerStyle()}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                {isMobile ? (
                  <select
                    value={telefono.countryCode}
                    onChange={handleChangeCountry}
                    style={{
                      width: (() => {
                        const codeLength = telefono.countryCode?.length || 0;
                        if (codeLength <= 2) return "35px";
                        if (codeLength === 3) return "45px";
                        return "55px";
                      })(),
                      marginLeft: "4px",
                      marginRight: "4px",
                      fontFamily: "Quicksand-Regular",
                      fontSize: "14px",
                      color: "#4F4F4F",
                      padding: 0,
                      border: "none",
                      outline: "none",
                      background: "transparent",
                      cursor: "pointer",
                    }}
                  >
                    {COUNTRIES.map((country) => (
                      <option
                        key={`${country.code}${'\u00A0'.repeat(6)}${country.name}`}
                        value={country.code}
                      >
                        {`${country.code}${'\u00A0'.repeat(6)}${country.name}`}
                      </option>
                    ))}
                  </select>
                ) : (
                  <Select
                    value={telefono.countryCode}
                    onChange={handleChangeCountry}
                    renderValue={(value) => value}
                    IconComponent={KeyboardArrowDown}
                    sx={{
                      width: "72.5px",
                      marginLeft: "4px",
                      marginRight: "4px",
                      "& .MuiSelect-select": {
                        fontFamily: "Quicksand-Regular",
                        fontSize: { md: "16px", xs: "14px" },
                        color: "#4F4F4F",
                        padding: 0,
                      },
                      "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                      "& .MuiSelect-icon": { color: "#4F4F4F" },
                    }}
                    MenuProps={{
                      PaperProps: { sx: { maxHeight: 300 } },
                    }}
                  >
                    {COUNTRIES.map((country) => (
                      <MenuItem
                        key={`${country.code}-${country.name}`}
                        value={country.code}
                        sx={{
                          fontFamily: "Quicksand-Regular",
                          fontSize: { md: "14px", xs: "12px" },
                        }}
                      >
                        <span style={{ marginLeft: "4px" }}>
                          {`${country.code}      ${country.name}`}
                        </span>
                      </MenuItem>
                    ))}
                  </Select>
                )}
                <TextField
                  value={telefono.number}
                  onChange={handleChangeTelefono}
                  variant="standard"
                  fullWidth
                  InputProps={{
                    disableUnderline: true,
                    sx: {
                      border: "none",
                      flex: 1,
                      outline: "none",
                      background: "transparent",
                      borderLeft: "2px solid #d0d0d0",
                      paddingLeft: "6px",
                      fontFamily: "Quicksand-Regular",
                      color: "#191C1F",
                      fontSize: { md: "16px", xs: "14px" },
                      "& input": { padding: 0 },
                    },
                  }}
                />
              </Box>
            </Box>
          </Box>


          {/* Desglose de precios (solo si no es gratis) */}
          {!isContentFree && (
            <Box sx={{ width: "100%", mb: 2, backgroundColor: "#f5f5f5", borderRadius: 2, p: 2, boxSizing: "border-box" }}>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 0.5 }}>
                <Typography
                  sx={{
                    fontFamily: "Quicksand-Regular",
                    fontSize: { md: "16px", xs: "14px" },
                    color: "#191C1F",
                  }}
                >
                  Contenido digital
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Quicksand-Regular",
                    fontSize: { md: "16px", xs: "14px" },
                    color: "#191C1F",
                  }}
                >
                  {precioBase}
                </Typography>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 0.5 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  <Typography
                    sx={{
                      fontFamily: "Quicksand-Regular",
                      fontSize: { md: "16px", xs: "14px" },
                      color: "#191C1F",
                    }}
                  >
                    Cargo por servicio
                  </Typography>
                  <InfoIcon
                    onClick={() => setShowInfoSheet(true)}
                    sx={{
                      fontSize: { md: "18px", xs: "16px" },
                      color: "#D6D6D6",
                      cursor: "pointer",
                    }}
                  />
                </Box>
                <Typography
                  sx={{
                    fontFamily: "Quicksand-Regular",
                    fontSize: { md: "16px", xs: "14px" },
                    color: "#191C1F",
                  }}
                >
                  {cargoServicio}
                </Typography>
              </Box>
              <Box
                sx={{
                  borderTop: "1px solid #d0d0d0",
                  my: 1,
                }}
              />
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Typography
                  sx={{
                    fontFamily: "Quicksand-Bold",
                    fontSize: { md: "18px", xs: "16px" },
                    color: "#191C1F",
                  }}
                >
                  Total a pagar
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Quicksand-Bold",
                    fontSize: { md: "18px", xs: "16px" },
                    color: "#191C1F",
                  }}
                >
                  {precioTotal}
                </Typography>
              </Box>
            </Box>
          )}

          {/* Botón principal */}
          <Button
            sx={{
              fontSize: { xs: "14px", md: "16px", lg: "16px" },
              fontFamily: "Quicksand-Bold",
              backgroundColor: "#3B82F6",
              "&:hover": { backgroundColor: "#2563EB" },
              borderRadius: 2,
              width: "100%",
              paddingTop: 2,
              paddingBottom: 2,
              mb: 3,
            }}
            variant="contained"
            disabled={!isFormValid || isLoading}
            onClick={handlePagar}
          >
            {isLoading ? (
              <CircularProgress size={20} sx={{ color: "white", mr: 1 }} />
            ) : (
              isContentFree ? "OBTENER" : `Pagar ${precioTotal}`
            )}
          </Button>

          {/* Alerta amarilla rotativa */}
          {getValidationAlert(nombreCompleto, email, confirmEmail, telefono) && (
            <Box
              sx={{
                backgroundColor: "#FFF9E6",
                padding: 1,
                borderRadius: 2,
                mb: 2,
                textAlign: "center",
                width: "100%",
                boxSizing: "border-box",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Quicksand-Regular",
                  fontSize: { md: "14px", xs: "12px" },
                  color: "#836516",
                }}
              >
                {getValidationAlert(nombreCompleto, email, confirmEmail, telefono)}
              </Typography>
            </Box>
          )}

          {/* Botón volver */}
          <Button
            onClick={handleGoBack}
            sx={{
              fontFamily: "Quicksand-Bold",
              fontSize: { md: "16px", xs: "14px" },
              color: "#007FFF",
              "&:hover": { backgroundColor: "rgba(59, 130, 246, 0.1)" },
              borderRadius: 3,
              textTransform: "none",
            }}
          >
            Volver
          </Button>
        </Box>
      </Box>

      {/* Overlay oscuro + Bottom sheet de info cargo por servicio */}
      {showInfoSheet && (
        <>
          {/* Backdrop oscuro */}
          <Box
            onClick={closeSheet}
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.35)",
              zIndex: 1299,
              animation: isClosingSheet
                ? "fadeOutBackdropContenidoComprar 0.22s ease forwards"
                : "fadeInBackdropContenidoComprar 0.22s ease",
              "@keyframes fadeInBackdropContenidoComprar": {
                from: { opacity: 0 },
                to: { opacity: 1 },
              },
              "@keyframes fadeOutBackdropContenidoComprar": {
                from: { opacity: 1 },
                to: { opacity: 0 },
              },
            }}
          />
          <Box
            ref={sheetRef}
            sx={{
              position: "fixed",
              bottom: 0,
              left: isMobile ? 0 : "50%",
              transform: isMobile ? "none" : "translateX(-50%)",
              width: isMobile ? "100%" : "800px",
              maxWidth: isMobile ? "100%" : "800px",
              zIndex: 1300,
              backgroundColor: "#ffffff",
              borderTopLeftRadius: "20px",
              borderTopRightRadius: "20px",
              p: 2.5,
              boxSizing: "border-box",
              animation: isClosingSheet
                ? "slideDownInfoContenido 0.22s ease-in forwards"
                : "slideUpInfoContenido 0.22s ease-out",
              "@keyframes slideUpInfoContenido": {
                from: {
                  transform: isMobile
                    ? "translateY(100%)"
                    : "translateX(-50%) translateY(100%)",
                },
                to: {
                  transform: isMobile
                    ? "translateY(0)"
                    : "translateX(-50%) translateY(0)",
                },
              },
              "@keyframes slideDownInfoContenido": {
                from: {
                  transform: isMobile
                    ? "translateY(0)"
                    : "translateX(-50%) translateY(0)",
                },
                to: {
                  transform: isMobile
                    ? "translateY(100%)"
                    : "translateX(-50%) translateY(100%)",
                },
              },
            }}
          >
            {/* Pill handle */}
            <Box sx={{ width: 36, height: 4, borderRadius: 2, backgroundColor: "#d1d5db", margin: "0 auto 20px" }} />

            {/* Texto explicativo */}
            <Box
              sx={{
                width: "100%",
                border: "1px solid #e5e7eb",
                borderRadius: "14px",
                px: 2,
                py: 1.5,
                fontFamily: "Quicksand-Regular",
                fontSize: { md: "16px", xs: "14px" },
                color: "#191C1F",
                backgroundColor: "#ffffff",
                boxSizing: "border-box",
                mb: 1.25,
                textAlign: "center",
                lineHeight: 1.5,
              }}
            >
              Cargo por servicio asociado a la compra de contenido digital en la plataforma
            </Box>

            {/* Botón Entendido */}
            <Box
              onClick={closeSheet}
              sx={{
                width: "100%",
                border: "none",
                borderRadius: "14px",
                px: 2,
                py: 1.5,
                fontFamily: "Quicksand-Bold",
                fontSize: { md: "16px", xs: "14px" },
                color: "#ffffff",
                backgroundColor: "#3B82F6",
                boxSizing: "border-box",
                textAlign: "center",
                cursor: "pointer",
                transition: "background-color 0.2s ease",
                userSelect: "none",
                "&:hover": {
                  backgroundColor: "#2563EB",
                },
                "&:active": {
                  backgroundColor: "#2563EB",
                },
              }}
            >
              Entendido
            </Box>
          </Box>
        </>
      )}
    </>
  );
}

export default ContenidoComprar;
